export default __webpack_public_path__ + "static/media/fine_emoji.35fbe6cd.png";